import dayjs from 'dayjs'
import { Periods } from './Constants'

/**
 * @typedef { { startDate: string, endDate: string } } Range
 * @param { keyof Omit<Periods, "CALENDAR"> | Range } period
 * @return {Range}
 */
export default period => {
  switch (period) {
    case Periods.CURRENT_MONTH: {
      return currentMonth()
    }
    case Periods.LAST_MONTH: {
      return lastMonth()
    }
    case Periods.TOTAL: {
      return total()
    }
    case Periods.TODAY: {
      return today()
    }
    case Periods.YESTERDAY: {
      return yesterday()
    }
    case Periods.LAST_7_DAYS: {
      return last7Days()
    }
    case Periods.LAST_30_DAYS: {
      return last30Days()
    }
    default: {
      return period
    }
  }
}

const dateFormat = 'YYYY-MM-DD'
const formatDate = date => date.format(dateFormat)
const formatRange = ({ startDate, endDate }) => ({
  startDate: formatDate(startDate),
  endDate: formatDate(endDate),
})

const currentMonth = () =>
  formatRange({ startDate: dayjs().startOf('month'), endDate: dayjs() })

const lastMonth = () =>
  formatRange({
    startDate: dayjs()
      .subtract(1, 'month')
      .startOf('month'),
    endDate: dayjs()
      .subtract(1, 'month')
      .endOf('month'),
  })

const total = () => ({ startDate: null, endDate: null })

const today = () => formatRange({ startDate: dayjs(), endDate: dayjs() })

const yesterday = () =>
  formatRange({
    startDate: dayjs().subtract(1, 'day'),
    endDate: dayjs().subtract(1, 'day'),
  })

const last7Days = () =>
  formatRange({
    startDate: dayjs().subtract(7, 'day'),
    endDate: dayjs().subtract(1, 'day'),
  })

const last30Days = () =>
  formatRange({
    startDate: dayjs().subtract(30, 'day'),
    endDate: dayjs().subtract(1, 'day'),
  })
